import { Disposer, ElementAttrs, IView } from '../interface/view.interface';
import { IViewService } from '../interface/view-service.interface';

/**
 * View类实现基础逻辑
 */
export default abstract class BaseView<P = {}> implements IView<P> {
    /**
     * view绑定的service
     * @protected
     */
    protected viewService?: IViewService<P>;

    public bindViewService(service: IViewService<P>): void {
        this.viewService = service;
    }

    public unBindViewService() {
        this.viewService = undefined;
    }

    /**
     * 更新View中元素，需要子类继承实现，不同组件实现方式不同
     * @param id
     * @param attr
     */
    public updateElement(id: string, attr: ElementAttrs) {
        // 子类继承实现，非必须
    }

    /**
     * 根据id获取具体元素，需要子类继承实现，不同组件实现方式不同
     * @param id
     */
    public getElementById(id: string): any {
        // 子类继承实现，非必须
    }

    public disposeOnUnmount<TF extends Disposer | Disposer[]>(fn: TF): TF {
        // 子类重写
        return fn;
    }

    public abstract forceRender(callBack?: () => void);

    public abstract getProps(): P | undefined;

    public abstract renderView(callBack?: () => void): void;
}
